import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/src/ScrollTrigger'

import konamiCode from './utilities/konami-code.js'

import '../../components/atoms/**/*.js'
import '../../components/molecules/**/*.js'
import '../../components/organisms/**/*.js'
import '../../components/structures/**/*.js'

console.log('\n %cMade with %c♥%c by Fabrique \n', 'font: 16px serif;', 'font: 13px serif; color: #f00;', 'font: 16px serif;')

// GSAP
window.GSAP = window.gsap ?? gsap
window.ScrollTrigger = window.ScrollTrigger ?? ScrollTrigger

window.GSAP.registerPlugin(window.ScrollTrigger)
window.GSAP.ticker.sleep() // Prevent GSAP ticker from leaking memory when not in use -EKL

// Check for re-layout and recalculate, otherwise ScrollTrigger can lose track -EKL
const observer = new ResizeObserver(() => window.ScrollTrigger.refresh())
observer.observe(document.body)

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
window.dispatchEvent(new CustomEvent('init-immediate'))
window.addEventListener('DOMContentLoaded', () => window.dispatchEvent(new CustomEvent('init-load')))
window.addEventListener('load', () => window.dispatchEvent(new CustomEvent('init-after-load')))
window.addEventListener('load', () => window.setTimeout(() => window.dispatchEvent(new CustomEvent('init-delayed-load')), 1000))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

konamiCode()

window.addEventListener('konami', () => {
  const randomIntBetween = (min = 0, max = 1) => Math.floor(Math.random() * (max - min + 1)) + min

  const sources = ['/static/media/kihyeon.jpg', '/static/media/elco.jpg', '/static/media/femke.jpg', '/static/media/mark.jpg', '/static/media/june.jpg']

  const speed = 30
  const scale = 0.25

  let canvas
  let ctx
  let logoColor

  const dvds = []

  const checkHitBox = dvd => {
    if (!dvd) {
      return
    }

    dvd.xspeed = dvd.x + dvd.img.width * scale >= canvas.width || dvd.x <= 0 ? dvd.xspeed * -1 : dvd.xspeed
    dvd.yspeed = dvd.y + dvd.img.height * scale >= canvas.height || dvd.y <= 0 ? dvd.yspeed * -1 : dvd.yspeed
  }

  const update = () => {
    setTimeout(() => {
      //ctx.fillStyle = '#000'
      //ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      ctx.fillStyle = logoColor

      dvds.forEach(dvd => {
        ctx.fillRect(dvd.x, dvd.y, dvd.img.width * scale, dvd.img.height * scale)
        ctx.drawImage(dvd.img, dvd.x, dvd.y, dvd.img.width * scale, dvd.img.height * scale)

        dvd.x += dvd.xspeed
        dvd.y += dvd.yspeed

        checkHitBox(dvd)
      })

      update()
    }, speed)
  }

  const main = () => {
    canvas = document.createElement('canvas')
    canvas.style.position = 'fixed'
    canvas.style.inset = 0
    canvas.style.zIndex = 9999
    document.body.appendChild(canvas)
    ctx = canvas.getContext('2d')

    const dvd = { x: randomIntBetween(0, window.innerWidth), y: randomIntBetween(0, window.innerHeight), xspeed: randomIntBetween(10, 25), yspeed: randomIntBetween(10, 25), img: new Image() }
    dvd.img.src = sources[randomIntBetween(0, sources.length - 1)]
    dvds.push(dvd)

    window.setInterval(() => {
      const dvd = { x: randomIntBetween(0, window.innerWidth), y: randomIntBetween(0, window.innerHeight), xspeed: randomIntBetween(10, 25), yspeed: randomIntBetween(10, 25), img: new Image() }
      dvd.img.src = sources[randomIntBetween(0, sources.length - 1)]
      dvds.push(dvd)
    }, 250)

    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    update()
  }

  main()
})

// eslint-disable-next-line no-undef
if (environment === 'debug') {
  const runAxe = async () => {
    const axe = (await import('axe-core')).default
    const results = await axe.run().catch(e => console.error(e))

    if (results.incomplete?.length) {
      results.incomplete.forEach(result => console.warn('Axe', result))
    }

    if (results.violations?.length) {
      results.violations.forEach(result => console.error('Axe', result))
    }
  }

  window.addEventListener('init-delayed-load', () => window.setTimeout(() => runAxe(), 1000))
}
